var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash-loader",class:{ hidden: _vm.hidden }},[_c('LogoSvg',{staticClass:"logo"}),_c('div',{staticClass:"progress"},[_c('div',{style:({ width: `${_vm.progress * 100}%` })})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }